import { OdmietnutieGestora, OdmietnutieGestoraApi } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new OdmietnutieGestoraApi(apiConfiguration(elegislativaPrefixPath));

const map = (dovodOdmietnutia: string): OdmietnutieGestora => ({
  dovodOdmietnutia,
});

// eslint-disable-next-line import/prefer-default-export
export const rejectGestor = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: Uuid,
  dovodOdmietnutia: string,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.rejectGestor(
    type,
    year,
    index,
    pracovnyKrokId,
    map(dovodOdmietnutia),
    headers,
  );
  return {
    responseCode: status,
  };
};
